<template>
  <div class="trackcode-list-page">
    <TrackCodes :progressCode="[120, 130, 140, 150, 170, 180, 210]" :isPaid="false" />
  </div>
</template>
<script>
import TrackCodes from '@/components/TrackCodesComponent.vue'

export default {
  name: 'TrackCodeList',
  components: {
    TrackCodes
  }
}
</script>

<style scoped>
.trackcode-list-page {
  min-height: 100%;
}
</style>
